export default __webpack_public_path__ + "static/media/559.99aa7c1c.JPG";